module.exports = __webpack_public_path__ + "img/logo.fb22cec8.png";